// extracted by mini-css-extract-plugin
export default {"container":"Synchronizer_container__EtITj","btn":"Synchronizer_btn__YuvMa"};